import React, { useEffect, useRef, useState } from 'react'
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import { calculateDistance, closeIcon, directionIcon, getCustomMarker, getDirectionUrl, getLocalStorageData, getStarForPopup, phoneIcon, updateQueryParams } from '../../utils/commanFunctions';
import { useNavigate } from 'react-router';
import CircularCheck from '../commonAssests/CircularCheck.svg'
// import CustomModal from '../Modal/CustomModal';
import UI from '../DataWithFilter/UI';
import { fetchHotelDetails } from '../../ServerCall';
import Home from '../Home/Home';
import { Header } from '../common/Header';
import { translations } from '../../contentConfig';

const PersonalizedStayMapPage = () => {
    const [store, setStore] = useState([]);
    const [hotelData, setHotelData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [noData, setNoData] = useState(false);
    // const [selectedFilter, setSelectedFilter] = useState({
    //   "display_value": "All",
    //   "query_value": "all"
    // });
    // const selectedFilterRef = useRef(null)

    const mapContainer = useRef(null);
    const map = useRef(null);
    let navigate = useNavigate();

    const setHotelDataF = async() =>{
        const fetchedHotelData = await fetchHotelDetails();
        if (fetchedHotelData.status) {
          setHotelData(fetchedHotelData.data);
        } else {
          console.log(fetchedHotelData);
        }
    }

    useEffect(()=>{
        const appData = localStorage.getItem("appData");
        let _d = JSON.parse(appData)
        // if(_d?.allPlaceAndEvent){
        //   setStore(_d?.allPlaceAndEvent)
        //   setNoData(_d?.allPlaceAndEvent.length === 0)
        // }
        // else
        // setNoData(true)

        setHotelDataF()
     

        if(_d?.allPlaceAndEvent.length === 0) return
        if (map.current) return;
        mapboxgl.accessToken =
         process.env.REACT_APP_MAPBOX_API_KEY;
    
        map.current = new mapboxgl.Map({
          container: mapContainer.current,
          style: 'mapbox://styles/innspiremapbox/clv9b4wyu00p801ph33xi424i',
          zoom: 13,
          scrollZoom: true,
        });
    
        map.current.on("load", () => {
          map.current.addSource("places", {
            type: "geojson",
            data: _d?.allPlaceAndEvent || [],
          });
        });

    },[])

    useEffect(() => {
        if (map.current) {
          addMarkers();
        }
      }, [store]);


      useEffect(() => {
    
        if(Object.keys(hotelData).length>0)
            createPlaceWithMarker(hotelData,true,true)
      }, [hotelData]);


      const createPlaceWithMarker = (marker={},isHotel=false,fly=true)=>{
        if (marker.longitude && marker.latitude){
          if(isHotel){
            let images = marker.photo? [{
              id:1,
              image:marker.photo
            }]: [
              {
                id:1,
                image:"https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain"
              }
            ]
            let amenities = (marker.amenities && marker.amenities.length>0 ) ? marker.amenities :  marker.category? [marker.category]:[]
            marker = {
              ...marker,amenities,images
            }
          }
    
          // marker creating ...........
          let existingMarker = document.getElementById(`marker-${marker.id}`)
          if(existingMarker)
          existingMarker.remove()
        const el = document.createElement("img");
        el.id = `marker-${marker.id}`;
        //   "https://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-File.png"
    
     if(isHotel){
      el.src = marker?.photo ? marker.photo : getCustomMarker(localStorage.getItem('primaryColor')?`#${localStorage.getItem('primaryColor')}`:"#080808")
      el.style.width = "40px";
     }else{
      el.src =marker.images && marker.images.length > 0 ? marker.images[0].image : getCustomMarker(`red`)
      el.style.width = "25px";
     }
        el.classList = "ellipse"
        new mapboxgl.Marker(el, { offset: [0, -23] })
        .setLngLat([marker.longitude, marker.latitude])
        .addTo(map.current);
        el.addEventListener("click",  (e) => {
          flyToStore(marker);
          //  createPopUp(marker,isHotel);
        });
    // marker createing end .....
    
    if(fly){
      map?.current?.flyTo({
        center: [Number(marker?.longitude), Number(marker?.latitude)],
        zoom: 13,
      });
    //   createPopUp(marker);
    }
    
    
        }
      }


      const calculateParallelDistance = (id,parameter)=>{
        calculateDistance(parameter,"miles").then((d)=>{
          if(d.status){
           let ele =  document.getElementById(id)
           if(ele)
           ele.innerText = d.data
          }
        })
      }
    
    
      const createPopUpHtml = (data,isHotel) => {
        const altImag = `https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain`
        let html = '';
        let distanceId  = `distanc-${data.id}`
        if(data.latitude && data.longitude && !isHotel)
        calculateParallelDistance(distanceId,[data.latitude,data.longitude])
    
        let imgageDiv = document.createElement("div")
        imgageDiv.classList = "imgage"
        let image = document.createElement("img")
        
        image.src = (data.images && data.images.length > 0)? data.images[0]?.image:altImag
        image.classList = "w-[100%] h-[15vh] md:h-[20vh] skeleton"
        if(hotelData.id !== data.id)
        image.onclick = (e)=>{
         e.preventDefault();
         const path =  updateQueryParams({
          path:"description",
          ID : data.id
        })
          navigate(path);
       }
        imgageDiv.appendChild(image)
        const crossIcon = document.createElement("img")
        crossIcon.src = closeIcon("red")
        crossIcon.classList = 'absolute top-[10px] right-[10px] w-[20px] cursor-pointer'
        imgageDiv.appendChild(crossIcon)
        
        crossIcon.onclick = (e)=>{
          e.preventDefault();
          const popUps = document.getElementsByClassName("mapboxgl-popup");
          if (popUps[0]) popUps[0].remove();
        }
    
        // Create the content div
        html += `<div class="content bg-white w-[100%] p-3 md:p-5">`;
    
        // Title
        html += `<div class="one w-[100%]  flex items-start justify-between mb-4"> <span class="text-base md:text-1xl max-w-[75%] font-bold">${data.name}</span>
        <div class="buttons flex items-center justify-center gap-4">
         <span>
         ${
          data?.name?`  <a href="${getDirectionUrl(data.name)}" style="text-decoration:none border:none" target="_blank">
          <img src="${directionIcon()}" alt="" class="w-[20px]"/>
          </a>`:``
        }
        
         </span>
         <span>
      ${
        data?.phone_number?`   <a href="tel:${data?.phone_number}" >
        <img src="${phoneIcon()}" alt="" class="w-[18px]"/>
        </a>`:``
      }
         </span>
        </div></div>`;
    
        // Address
        // html += `<div class="three mb-2"><p class="text-md md:text-lg font-medium">${data.address}</p></div>`;
    
    
      // star 
      html +=`   <div class="mb-2 flex items-center justify-start gap-3">
    ${data.rating?`  <div class="flex items-center justify-start gap-1">
    <span class="text-gray-600 font-medium text-sm md:text-md mt-[0.2rem]">${data.rating}</span> 
        <div class="flex items-center justify-center gap-1">
        ${getStarForPopup(data.rating)}
        </div>
        </div>
            <span class="text-gray-600 font-medium text-sm md:text-lg">(${data?.reviews_count})</span>`:""}
             ${!isHotel?`      <div class="flex items-center justify-center gap-1">
            <img src="${getCustomMarker("green")}" alt="" class="w-[13px]" />
            <span id="${distanceId}" class="text-gray-600 font-medium text-sm md:text-lg min-w-[55px] text-center">--</span>
          </div>`:``}
              </div>
          `
    
        // tags 
        
        let tagCount = window.innerWidth>700?2:2
        let arr = []  
    
        if(data.amenities && data.amenities.length>0)
        arr = data.amenities 
      else if (data?.category)
      arr = [data.category?.display_name]
    
    if(arr.length>0)
    {
      html += `<div class="two flex items-center justify-start gap-2 flex-wrap">`
      arr = arr.slice(0,tagCount)
      let tags =""
      for(let i of arr){
         tags += `<div class="flex items-center justify-start gap-1">
        <img src="${CircularCheck}" alt="" />
        <span class="text-gray-600 font-medium text-md md:text-lg">${i}</span>
    </div>`
      }
     html += tags
    
      html += `</div>`
    
      // Close content div
      html += `</div>`;
    }
    
        const mainContainer = document.createElement("div");
        mainContainer.style.fontFamily = "MyFont"
           mainContainer.classList = "popup-dimension"
    mainContainer.appendChild(imgageDiv)
    mainContainer.insertAdjacentHTML("beforeend",html)
    return mainContainer
    };
    
    
    
    
    
      function flyToStore(currentFeature) {
        if (Object.keys(currentFeature).length > 0){
          map.current.flyTo({
            center: [currentFeature.longitude, currentFeature.latitude],
            zoom: 15,
          });
          const storeElement = document.getElementById(`${currentFeature.id}`);
          if (storeElement) {
            storeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest', 
              inline: 'center' 
            });
          }
        }
      }
    
    
      function createPopUp(currentFeature,isHotel) {
        const popUps = document.getElementsByClassName("mapboxgl-popup");
        if (popUps[0]) popUps[0].remove();
        const popup = new mapboxgl.Popup({ closeOnClick: false }); 
        const popupContent =  createPopUpHtml(currentFeature,isHotel)
      
        popup.setLngLat([currentFeature.longitude, currentFeature.latitude])
          .setDOMContent(popupContent)
          // .setHTML(``)
          .addTo(map.current);
  
      }
    
      
      
    
      function addMarkers(data) {
        const markers = document.querySelectorAll(".mapboxgl-marker");
        markers.forEach(marker => {
          if(!hotelData.id  || marker.id != `marker-${hotelData?.id}`)
          marker.remove()
        });
        if (!data) data = store;
        
        for (const marker of data) {
          if (!marker.longitude || !marker.latitude) continue;
          const el = document.createElement("img");
          el.id = `marker-${marker.id}`;
          // el.style.backgroundImage = `./assets/marker.png`
          //  el.src = `${marker?.marker_image ||'https://docs.mapbox.com/help/demos/building-a-store-locator/marker.png'})`;
          // el.src = getCustomMarker(`red`)
          el.src = marker.images && marker.images.length > 0 ? marker.images[0].image : getCustomMarker(`red`)
          el.classList = "ellipse"
    
          new mapboxgl.Marker(el, { offset: [0, -23] })
            .setLngLat([marker.longitude, marker.latitude])
            .addTo(map.current);
    
            el.addEventListener("click", (e) => {
              flyToStore(marker);
              //  createPopUp(marker);
            });
        }
      }



  return (
    <Home showBottomNav={true} showPersonalizedButton={false} showOldFilter={false}>
        <Header  data={{
      // title:"Personalized Stay",
      // buttonText:"Redo",
       buttonUrl:updateQueryParams({path:"personalizedStayModal"})
      // buttonUrl:"/?path=personalizedStayModal"
    }}
            showFilter={false}
            showSearch={false}
            showBookMark={false}
            setData={setStore}
            isloading={isLoading}
            setIsLoading={setIsLoading}
            noData={noData}
            setNoData={setNoData}
            filterType={"local"} 
            myPosition='relative'
            // selectedFilterRef={selectedFilterRef}
  />
          <div
          ref={mapContainer}
          className="map border-2  h-[30vh]"
        ></div>
        {/* <CustomModal additionClass='' blurbg={""} isOpen={true} setIsOpen={()=>{}} showCloseButton={true} Content={<UI data={store} parentDivClass={"overflow-y-auto h-[70vh]"} isFilter={false} heading='Personalized Stay'/>}/> */}
        <UI data={store} parentDivClass={"overflow-y-auto h-[calc(70vh-128px)] personalized-stay-map-page-ui"}  isFilter={true} heading='' filterType={"local"} 
              // selectedFilter={getLocalStorageData("selectedFilterNew",{})}
              showHeader={true}
              // setSelectedFilter={setSelectedFilter}
              // setData={setStore}
              // isloading={isLoading}
              // setIsLoading={setIsLoading}
              noData={noData}
              // setNoData={setNoData}
              name={`We found ${store.length > 0 ? store.length : ""} results`}
        />
    </Home>
  )
}

export default PersonalizedStayMapPage
